import styled from "styled-components";

export const CityImage = styled.img`
  width: 100%;
  height: auto;
  max-height: 545px;
  border-radius: 16px;
  object-fit: cover;
  margin-top: 32px;
`;

export const Title = styled.h3`
  color: var(--primary);
  font-weight: 600;
  font-size: 2rem;
`;

export const Text = styled.p`
  font-weight: 300;
  font-size: 1.125rem;
  color: var(--neutral);
  text-align: justify;
`;

export const TextContainer = styled.div`
  width: calc(100% - 80px);
  padding-left: 40px;
  padding-right: 40px;

  @media (max-width: 960px) {
    width: calc(100% - 40px);
    padding-left: 20px;
    padding-right: 20px;
  }

  @media(max-width: 768px) {
    width: 100%;
    padding: 0px;
  }
`;

export const Section = styled.section`
  margin-bottom: 48px;
`;

export const SubTitle = styled.h2`
  color: var(--primary);
  font-size: 1.75rem;
  font-weight: 600;
  margin-bottom: 16px;
`;

export const AccessibilityTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 24px;
`;

export const TableHead = styled.th`
  border: 1px solid #ccc;
  padding: 12px;
  text-align: left;
  background: #f5f5f5;
`;

export const TableCell = styled.td`
  border: 1px solid #ccc;
  padding: 12px;
`;

export const ResourceList = styled.ul`
  padding-left: 24px;
`;

export const ResourceItem = styled.li`
  margin-bottom: 12px;
  font-size: 1.125rem;
  color: var(--neutral);
`;
